module.exports = __webpack_public_path__ + "static/media/creditcard-512.43dcb84e.png";